module.exports = __webpack_public_path__ + "static/media/Bíceps.107ce56c.png";